import { Settings } from './settings.model';
import { CompletionType } from '../enums/CompletionType.enum';

export class Configuration {
  configurationId: string;
  settings: Settings = new Settings();
  language: string;
  completionType: CompletionType = CompletionType.None;

  clone(): Configuration {
    const newConfig = new Configuration();
    newConfig.configurationId = this.configurationId;
    newConfig.settings = this.settings.clone();
    newConfig.settings.doorSettings = [];
    this.settings.doorSettings.forEach(d => {
      newConfig.settings.doorSettings.push(d.clone());
    });
    this.settings.innerWalls.forEach(iw => {
      newConfig.settings.innerWalls.push(Object.assign({}, iw));
    });
    newConfig.language = this.language;
    return newConfig;
  }
}
